module.exports = __webpack_public_path__ + "static/media/IMG_4899.d99ed0b2.JPG";